// Show max char count
export default (form) => {
    const charCounts = Array.from(form.querySelectorAll('*[maxlength]'));
    charCounts.forEach((element) => {
        const maxLength = element.getAttribute('maxlength');
        const counter = document.createElement('span');
        counter.classList.add('char-count');
        element.parentElement.appendChild(counter);
        counter.innerHTML = maxLength;
        element.addEventListener('keyup', () => {
            counter.innerHTML = maxLength - element.value.length;
        });
        counter.innerHTML = maxLength - element.value.length;
    });
};
